module.exports = __webpack_public_path__ + "img/forecast.fcc3af0f.svg";